import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { dashboardStyles } from '../Styles/dashboardStyles';
import { inject, observer } from 'mobx-react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';
import { ReactSVG } from 'react-svg'
import Images from '../Theme/Images';
import InitialHelpDialog from '../Components/Onboarding/InitialHelpDialog';

@inject('commonStore', 'adminStore', 'userStore', 'dashboardStore')
@observer
class Header extends Component {

    state = {
        searchText: '',
        menu: null
    }
    openUserMenu = event => {
        this.setState({
            menu: true
        })
    };

    closeUserMenu = () => {
        this.setState({
            menu: null
        })
    };

    logout = () => {
        this.props.userStore.logout()
            .then(() => {
                if (this.props.userStore.logoutSuccess)
                    this.props.history.push("/")
            })
    }

    searchDocuments = (event) => {
        const { searchText } = this.state;
        const { documentList } = this.props.dashboardStore;
        let docStatus = this.props.filter;
        if (event.which === 13 ) {
            if (searchText.replace(/\s/g, "").length >= 2)
                this.props.dashboardStore.searchDocuments(searchText, docStatus)
            else
                this.props.commonStore.handleOpenSnackBar("Enter atleast two characters to search!", "info")
        }
    }

    searchBlockList = (event) => {
        const { searchText } = this.state;
        const { blockedList } = this.props.adminStore;
        let filter = this.props.filter;
        if (event.which === 13 ) {
            if (searchText.replace(/\s/g, "").length >= 2)
                this.props.adminStore.searchBlockedList(searchText, filter)
            else
                this.props.commonStore.handleOpenSnackBar("Enter atleast two characters to search!", "info")
        }
    }

    searchEnterpriseList = (event) => {
        const { searchText } = this.state;
        const { enterpriseList } = this.props.adminStore;
        if (event.which === 13) {
            if (searchText.replace(/\s/g, "").length >= 2)
                this.props.adminStore.searchEnterpriseList(searchText)
            else
                this.props.commonStore.handleOpenSnackBar("Enter atleast two characters to search!", "info")
        }
    }

    clearSearch = () => {
        const { searchType } = this.props;
        this.setState({
            searchText: ''
        })
        if (searchType === "users")
            this.props.adminStore.searchUserList(false, undefined)
        else if (searchType === "enterprises")
            this.props.adminStore.searchEnterpriseList(undefined)
        else
            this.props.dashboardStore.searchDocuments(undefined, this.props.filter)
            this.props.dashboardStore.resumeUpdating()

    }

    openUserMgmt = () => {
        this.props.commonStore.setActiveTab('users');
        this.props.history.push('/admin/manageUsers')
    }

    openSettings = () => {
        this.props.commonStore.setActiveTab('settings');
        this.props.history.push('/user/settings');
        this.closeUserMenu()
    }

    openHelp = () => {
        this.props.commonStore.openHelpDialog(true);
        this.closeUserMenu()
    }

    openStatistics = () => {
        this.props.commonStore.setActiveTab('stats');
        this.props.history.push('/statistics/usage');
        this.closeUserMenu()
    }

    searchUsers = (event) => {
        const { searchText } = this.state;
        const { userList } = this.props.adminStore;
        if (event.which === 13) {
            if (this.state.searchText.replace(/\s/g, "").length >= 2)
                this.props.adminStore.searchUserList(false, encodeURIComponent(this.state.searchText))
            else
                this.props.commonStore.handleOpenSnackBar("Enter atleast two characters to search!", "info")
        }
    }

    render() {
        const { classes, searchType } = this.props;
        const { searchText, menu } = this.state;
        const { user } = this.props.userStore
        return (
            <div className="rowFlex">
                {searchType !== undefined ? <TextField
                    value={searchText}
                    placeholder="Search"
                    variant="filled"
                    onChange={(e) => this.setState({ searchText: e.target.value })}
                    onKeyPress={searchType == 'users' ? this.searchUsers : (searchType === 'blockList' ? this.searchBlockList : (searchType === 'enterprises' ? this.searchEnterpriseList : this.searchDocuments))}
                    InputProps={{
                        disableUnderline: true,
                        classes: {
                            input: classes.searchInput,
                        },
                        startAdornment:
                            <InputAdornment style={{ marginTop: '1px' }} position="start">
                                <ReactSVG src={Images.search} />
                            </InputAdornment>,
                        endAdornment:
                            <InputAdornment style={{ marginTop: '1px', cursor: 'pointer' }} position="end">
                                {searchText.length ? <CloseIcon onClick={(e) => { this.clearSearch() }} /> : null}
                            </InputAdornment>
                    }}
                /> : null
                }
                <div className={classes.profile}>
                    {
                        user.profilePic ? <img alt="profilePicture" onClick={(e) => this.openUserMenu()} className={classes.profilePic} src={user.profilePic}></img> : 
                        <AccountCircleIcon onClick={(e) => this.openUserMenu()} style={{ color: 'white', fontSize: '3vw', cursor: 'pointer' }} /> 
                    }
                </div>
                <Menu
                    style={{ top: '8%' }}
                    id="simple-menu"
                    anchorEl={menu}
                    open={Boolean(menu)}
                    onClose={this.closeUserMenu}
                    getContentAnchorEl={null}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <MenuItem onClick={this.closeUserMenu} style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className={classes.menuItems} >{user.userFullName}</div>
                        <div style={{ fontSize: '11px', color: '#868a8e' }}>{user.email}</div>
                    </MenuItem>
                    {user.userType !== "AGENT" ? <MenuItem className={classes.menuItems} onClick={this.openUserMgmt}>Manage Users</MenuItem> : null}
                    <MenuItem className={classes.menuItems} onClick={this.openStatistics}>Usage Statistics</MenuItem>
                    <MenuItem className={classes.menuItems} onClick={this.openSettings}>Settings</MenuItem>
                    <MenuItem className={classes.menuItems} onClick={this.openHelp}>Help</MenuItem>
                    <MenuItem className={classes.menuItems} onClick={this.logout}>Logout</MenuItem>
                </Menu>
                <InitialHelpDialog></InitialHelpDialog>
            </div>
        )
    }
}
Header.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(dashboardStyles)(withRouter(Header));
